import React from 'react';
import PropTypes from 'prop-types';

import '../../assets/styles/Input.css';

const Input = ({
    label, type, value, icon, maxLength = 60, isRequired, handleChange, name, placeholder, className, onBlur, error, rows, cols,
}) => {
    const borderColor = error ? 'red' : null;
    return (
        <div id="forms_container">
            <fieldset className="login">
                <div className="form-group input-field">
                    {
                        label && (
                            <label>
                                {label}
                                {isRequired &&
                                <span
                                    style={{
                                        color: '#FF0000',
                                        paddingLeft: '5px',
                                    }}
                                >*
                                </span>}
                            </label>
                        )
                    }
                    {
                        rows ?
                            <textarea
                                name={name}
                                value={value || ''}
                                className={className || 'form-control'}
                                onChange={handleChange}
                                style={{ borderColor }}
                                rows={rows}
                                cols={cols}
                            />
                            :
                            <div className="single-input">
                                <input
                                    type={type}
                                    value={value || ''}
                                    maxLength={maxLength}
                                    className={className || 'form-control'}
                                    onChange={handleChange}
                                    name={name}
                                    placeholder={placeholder}
                                    onBlur={onBlur}
                                    style={{ borderColor }}
                                />
                                {
                                    icon ? <i className={`fa ${icon}`} /> : ''
                                }
                            </div>

                    }
                </div>
                {
                    error && (
                        <div className="flex-error">
                            {error}
                        </div>
                    )
                }
            </fieldset>
        </div>
    );
};

Input.defaultProps = {
    label: '',
    type: '',
    value: '',
    name: '',
    placeholder: '',
    className: '',
    icon: '',
    maxLength: 60,
    rows: 0,
    cols: 0,
    isRequired: false,
    error: null,
    handleChange: () => {},
    onBlur: () => {},
};

Input.propTypes = {
    label: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    icon: PropTypes.string, // icon should be fontawesome class name. e.g. fa-user
    maxLength: PropTypes.number,
    rows: PropTypes.number,
    cols: PropTypes.number,
    isRequired: PropTypes.bool,
    error: PropTypes.string,
    handleChange: PropTypes.func,
    onBlur: PropTypes.func,
};

export { Input };
